<template>
  <el-upload
    :before-upload="handleBeforeUpload"
    :http-request="handleHttpRequest"
    :on-change="handleChange"
    :on-progress="handleProgress"
    :show-file-list="false"
    accept="image/*"
    action="#"
    class="nf-upload-image"
    list-type="picture-card"
    :disabled="disabled"
    :drag="drag"
  >
    <div class="ca-value" :title="!value ? '点击上传' : ''">
      <img v-if="!value" alt="" class="ca-value-img" src="@/assets/images/capacity/kongimg.png" />
      <nf-image
        v-if="value"
        :ref="imageType"
        :preview-src-list="previewList"
        :src="changeImg(value)"
        class="ca-value-img"
        fit="fill"
      />
      <i
        v-if="value && removeExist"
        class="ca-remove el-icon-error"
        @click.stop="handleRemove"
        title="点击删除"
      />
      <div class="ca-pop">
        <i v-if="value" class="el-icon-view" @click.stop="handlePreview" title="查看大图" />
        <i class="el-icon-upload2" title="点击上传" />
      </div>
    </div>
    <slot />
  </el-upload>
</template>

<script>
import nfImage from '@/components/nf-image';
import * as imageConversion from 'image-conversion';
import ocrTypeMap from '@/utils/ocrTypeMap';
import { changeImg } from '@/utils';

export default {
  name: 'nfUploadImageNew',
  components: { nfImage },
  props: {
    value: {
      type: String,
      default: '',
    },
    filePath: {
      type: String,
      default: '',
    },
    imageType: {
      type: String,
      default: '',
    },
    previewList: {
      type: Array,
      default: () => [],
    },
    openCompression: {
      type: Boolean,
      default: true,
    },
    removeExist: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      errorList: [],
      changeImg,
    };
  },
  methods: {
    // 图片上传之前判断处理
    handleBeforeUpload(file, fileList) {
      const isPng =
        file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isPng) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 30MB!');
        return false;
      }
      return isPng && isLt2M;
    },
    // 压缩图片 imageConversion
    compressionPicture(file, size) {
      return new Promise((resolve, reject) => {
        imageConversion.compressAccurately(file, size).then(res => {
          const compressed_file = new File([res], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          compressed_file.uid = file.uid;
          return resolve(compressed_file);
        });
      });
    },
    // 拦截原生上传
    handleHttpRequest(file) {
      let uploadFile = '';
      if (this.openCompression) {
        this.compressionPicture(file.file, 5000).then(res => {
          this.imageUpload(res);
        });
      } else {
        uploadFile = file.raw;
        this.imageUpload(uploadFile);
      }
    },
    // 封装上传
    imageUpload(file) {
      const _this = this;
      const url = '/rest/upload/uploadAndOcr';
      let ocrType = 'AUTO';
      let dataMap = null;
      if (_this.imageType && ocrTypeMap[_this.imageType]) {
        ocrType = ocrTypeMap[_this.imageType].ocrType;
        dataMap = ocrTypeMap[_this.imageType].dataMap;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('filePath', _this.filePath);
      formData.append('ocrType', ocrType);

      _this.$http.post(url, formData).then(res => {
        const { code, data } = res;
        if (code === 200) {
          const newData = {};
          if (dataMap) {
            console.log(dataMap, ocrType, _this.imageType);
            Object.keys(dataMap).forEach(key => {
              switch (key) {
                case 'grossMass':
                case 'curbWeight':
                case 'approvedLoad':
                case 'totalTractionMass':
                  newData[dataMap[key]] = data[key] || '0';
                  break;
                default:
                  newData[dataMap[key]] = data[key];
                  break;
              }
            });
          }
          newData[_this.imageType] = `/rest/image/${data.ossPath}`;
          this.$emit('handleUpload', newData);
        }
      });
    },
    // 进度条
    handleProgress(event, file, fileList) {
      console.log(event, file, fileList, 'handleProgress');
    },
    // 移除图片
    handleRemove() {
      this.$emit('handleRemove', this.imageType);
    },
    handlePreview() {
      this.$refs[this.imageType].clickHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.nf-upload-image {
  width: 122px;

  ::v-deep .el-upload--picture-card {
    width: 122px;
    height: auto;
    border: 0;

    .el-upload-dragger {
      width: 122px;
      height: auto;
      padding: 5px;
      &.is-dragover {
        background-color: rgba(32, 159, 255, 0.06);
        border: 1px dashed #445ebf;
      }
    }
  }

  .ca-value {
    position: relative;
    width: 110px;
    height: 70px;
    line-height: 70px;

    .ca-value-img {
      width: 110px;
      height: 70px;
      border-radius: 4px;
    }

    .ca-remove {
      position: absolute;
      font-size: 20px;
      color: #f36807;
      right: -5px;
      top: -5px;
      z-index: 999;
      background-color: #fff;
      border-radius: 10px;
      padding: 0;
      display: none;
    }

    .ca-pop {
      width: 110px;
      height: 70px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      display: none;

      i {
        font-size: 20px;
        color: #ffffff;
        margin: 0 10px;
      }
    }
  }

  .el-upload-dragger:hover {
    .ca-pop {
      display: block;
    }

    .ca-remove {
      display: block;
    }
  }
}
</style>
